import {
  baseDestroyMapbox,
  baseInitMapbox,
  baseMapContextState,
  baseMapDestroy,
  baseMapInit,
} from './shared-map-context'
import type { MapComponentConfig } from '@/utils/mapbox/mapbox-component-config'
import type { MapBlock, MapBlockComponent } from '@/types/map/map.types'

export const map = ({
  camera,
  destinations,
  routes,
  isInteractiveMap,
  hideMapStats,
  options,
}: MapComponentConfig): MapBlockComponent<MapBlock> => ({
  ...baseMapContextState({ hideMapStats, options }),

  init() {
    baseMapInit(this as MapBlock)
  },

  destroy() {
    baseMapDestroy(this as MapBlock)
  },

  async initMapbox() {
    await baseInitMapbox(this as MapBlock, {
      camera,
      destinations,
      routes,
      isInteractiveMap,
    })
  },

  destroyMapbox() {
    baseDestroyMapbox(this as MapBlock)
  },
})
